import React from 'react'
import { RouteProp, useNavigation } from '@react-navigation/native'
import { useRoute } from '@react-navigation/core'
import { StackNavigationProp } from '@react-navigation/stack'
import {
  AppStackParamList,
  CommonAuthorizedStackParamList,
  OnboardingStackParamsList,
} from '@navigation/types'
import { ConfirmSteloEligibility } from '@src/screens/Dexcom/Stelo/components/ConfirmSteloEligibility'
import { ProductSelection } from '@src/screens/Marketplace/types/types'
import { SubscriptionCheckoutOptionKind } from '@src/types.ts'
import { useNavigateToCheckout } from '@screens/SignUp/hooks/useNavigateToCheckout.ts'
import { useSecureScreen } from '@src/hooks/useSecureScreen'

export const SteloCheckout = () => {
  useSecureScreen()

  const navigateToCheckout = useNavigateToCheckout()
  const navigation = useNavigation<
    StackNavigationProp<
      AppStackParamList & OnboardingStackParamsList & CommonAuthorizedStackParamList
    >
  >()
  const route = useRoute<
    | RouteProp<AppStackParamList, 'SteloCheckout'>
    | RouteProp<OnboardingStackParamsList, 'SteloCheckout'>
  >()
  const { checkoutKind, subscriptionId, product } = route.params || {}

  const onAddToCartPress = () => {
    if (product?.addon) {
      const selections = [{ product, quantity: 1 }]
      navigation.navigate('AddonCheckout', {
        selections: selections as [ProductSelection],
      })

      return
    }

    if (product) {
      navigateToCheckout({
        product,
        requireEligibilityCheck: false,
        checkoutOptionKinds: [SubscriptionCheckoutOptionKind.Stelo],
        checkoutKind,
        subscriptionId,
      })
      return
    }

    navigation.navigate('SteloSelectSubscription', { checkoutKind, subscriptionId })
  }

  const onIneligiblePress = () => {
    navigation.replace('ProgramError')
  }

  return (
    <ConfirmSteloEligibility
      actionCallback={onAddToCartPress}
      ineligibleCallback={onIneligiblePress}
      mode="checkout"
    />
  )
}
